export const STLogoTextHorizontal = (props: {
    height?: number;
    width?: number;
    className?: string;
}) => (
    <img
        src="/Assets/Images/stlogo.png"
        className={props.className || ''}
        style={{
            height: props.height ? props.height + 'px' : 'auto',
            width: props.height ? props.width + 'px' : 'auto',
        }}
    />
);
